import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BECSEDataScienceCoursePage: React.FC = () => {
  const courseData = {
    title: "B.E. CSE (Data Science)",
    shortName: "B.E. CSE (DS)",
    duration: "4 years",
    description: "Specialized computer science program focused on data analytics, machine learning, and statistical computing",
    overview: "Bachelor of Engineering in Computer Science and Engineering with specialization in Data Science (B.E. CSE Data Science) is a 4-year undergraduate program that combines core computer science principles with advanced data analytics, statistics, and machine learning. This course prepares students to extract insights from large datasets and build data-driven solutions for various industries.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Minimum 75% marks in JEE Main (50% for SC/ST)",
      "Valid JEE Main/State CET scores", 
      "Strong foundation in Mathematics and Statistics"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II",
          "Physics",
          "Chemistry",
          "Programming in Python",
          "Statistics and Probability",
          "Linear Algebra"
        ]
      },
      {
        year: 2,
        subjects: [
          "Data Structures and Algorithms",
          "Database Management Systems",
          "Discrete Mathematics",
          "Statistical Methods",
          "Object-Oriented Programming",
          "Data Visualization"
        ]
      },
      {
        year: 3,
        subjects: [
          "Machine Learning",
          "Big Data Analytics",
          "Data Mining",
          "Business Intelligence",
          "R Programming",
          "Deep Learning Fundamentals"
        ]
      },
      {
        year: 4,
        subjects: [
          "Advanced Machine Learning",
          "Natural Language Processing",
          "Computer Vision",
          "Data Science Project",
          "Industry Internship",
          "Research Methodology"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Data Scientist",
        "Data Analyst",
        "Machine Learning Engineer",
        "Business Intelligence Analyst", 
        "Data Engineer",
        "Research Scientist",
        "Quantitative Analyst",
        "AI Specialist"
      ],
      industries: [
        "Technology Companies",
        "Financial Services",
        "Healthcare and Pharmaceuticals",
        "E-commerce",
        "Consulting Firms",
        "Research Organizations",
        "Government Analytics",
        "Startups"
      ],
      averageSalary: "₹6-12 LPA (Fresher), ₹20-40 LPA (Experienced)",
      topRecruiters: [
        "Google, Microsoft, Amazon",
        "Netflix, Uber, Airbnb",
        "JPMorgan Chase, Goldman Sachs",
        "Flipkart, Swiggy, Zomato",
        "IBM, Oracle, SAS",
        "Mu Sigma, Fractal Analytics"
      ]
    },

    admissionProcess: [
      "TNEA Counselling (for Tamil Nadu colleges)",
      "JEE Main (for NITs and central universities)",
      "State-level entrance exams",
      "Management quota admissions",
      "Direct admission based on 12th marks"
    ],

    topColleges: [
      {
        name: "College of Engineering Guindy, Anna University",
        location: "Chennai",
        fees: "₹2,00,000",
        ranking: "NIRF Ranking: 35"
      },
      {
        name: "PSG College of Technology",
        location: "Coimbatore",
        fees: "₹4,50,000",
        ranking: "NIRF Ranking: 42"
      },
      {
        name: "SSN College of Engineering", 
        location: "Chennai",
        fees: "₹4,20,000",
        ranking: "NAAC A+ Grade"
      },
      {
        name: "Vellore Institute of Technology",
        location: "Chennai",
        fees: "₹1,98,000",
        ranking: "NIRF Ranking: 15"
      }
    ],

    skills: [
      "Python/R Programming",
      "Statistical Analysis",
      "Machine Learning",
      "Data Visualization", 
      "SQL and NoSQL Databases",
      "Big Data Technologies",
      "Deep Learning",
      "Business Acumen",
      "Critical Thinking",
      "Communication Skills"
    ],

    futureScope: "Extremely high demand in the era of big data and AI, with opportunities in emerging fields like AI ethics, automated machine learning, and edge analytics.",

    faqs: [
      {
        question: "How is Data Science different from regular CSE?",
        answer: "Data Science focuses specifically on extracting insights from data using statistics, machine learning, and analytics, while CSE covers broader computer science topics."
      },
      {
        question: "Do I need strong math skills for Data Science?",
        answer: "Yes, strong foundation in mathematics, statistics, and linear algebra is essential for understanding machine learning algorithms and statistical methods."
      },
      {
        question: "What programming languages are important?",
        answer: "Python and R are most important, along with SQL for databases. Knowledge of Scala, Java, and JavaScript can also be beneficial."
      },
      {
        question: "Are there good job prospects?",
        answer: "Excellent! Data Science is one of the fastest-growing fields with high salaries and demand across all industries."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BECSEDataScienceCoursePage;
